import React, { useState } from "react";
import { MessageCircle } from "lucide-react";
import siteSettings from "../data/site-settings.json";
import { WHATSAPP } from "../constants/testIds";

const WhatsAppButton = () => {
  const [hovered, setHovered] = useState(false);

  return (
    <div className="whatsapp-float" data-testid={WHATSAPP.floatingBtn}>
      <a
        href={`https://wa.me/${siteSettings.whatsapp}?text=${encodeURIComponent(
          "Hello AL ZAHRAN FLOUR MILL, I would like information about your products."
        )}`}
        target="_blank"
        rel="noopener noreferrer"
        className="relative flex items-center justify-center group"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        aria-label="Chat on WhatsApp"
      >
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-30 animate-ping" />

        {/* Tooltip */}
        {hovered && (
          <span className="absolute right-16 bg-deepCharcoal text-white text-xs font-outfit font-medium px-3 py-2 rounded-sm whitespace-nowrap shadow-lg">
            Chat on WhatsApp
          </span>
        )}

        {/* Button */}
        <div className="relative w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:bg-[#1EBE5A] transition-colors duration-200">
          <MessageCircle size={26} color="white" fill="white" />
        </div>
      </a>
    </div>
  );
};

export default WhatsAppButton;
